/* =========================================================
   COC / Fuji Slideshow "BOWA" controller（拡大しない版）
   - active監視 → 新activeに coc-pop
   - 直前activeに coc-prev
   - 初回はreadyを遅らせて違和感を防ぐ
========================================================= */
(() => {
  const READY_CLASS = "coc-bw-ready";
  const PREV_CLASS  = "coc-prev";
  const POP_CLASS   = "coc-pop";

  function getSlides(root){
    return Array.from(root.querySelectorAll(".js-slideshow-item"));
  }

  function getActive(slides){
    return slides.find(s => s.classList.contains("slider-slide--active"))
      || slides.find(s => s.getAttribute("aria-hidden") === "false")
      || slides[0]
      || null;
  }

  function restartClass(el, cls){
    el.classList.remove(cls);
    void el.offsetWidth; // アニメ確実に再スタート
    el.classList.add(cls);
  }

  function setup(root){
    const slides = getSlides(root);
    if (slides.length < 2) return;

    slides.forEach(s => s.classList.remove(PREV_CLASS, POP_CLASS));

    let lastActive = getActive(slides);

    const onChange = () => {
      const now = getActive(slides);
      if (!now) return;
      if (now === lastActive) return;

      // 直前：消える演出
      if (lastActive) {
        lastActive.classList.remove(POP_CLASS);
        restartClass(lastActive, PREV_CLASS);
        setTimeout(() => lastActive && lastActive.classList.remove(PREV_CLASS), 2800);
      }

      // 新active：入口ボワッ
      now.classList.remove(PREV_CLASS);
      restartClass(now, POP_CLASS);
      setTimeout(() => now && now.classList.remove(POP_CLASS), 2400);

      // 掃除
      slides.forEach(s => {
        if (s !== lastActive && s !== now) s.classList.remove(PREV_CLASS, POP_CLASS);
      });

      lastActive = now;
    };

    const mo = new MutationObserver(onChange);
    slides.forEach(s => mo.observe(s, { attributes: true, attributeFilter: ["class", "aria-hidden"] }));

    // 念のため
    setTimeout(onChange, 500);
    setTimeout(onChange, 1200);
  }

  function boot(){
    if (!document.body.classList.contains("template-index")) return;

    document.querySelectorAll("sht-slideshow").forEach(setup);

    requestAnimationFrame(() => {
      setTimeout(() => document.body.classList.add(READY_CLASS), 200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
